import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-navy-950 font-body text-gray-100">
      <div className="max-w-3xl mx-auto px-6 py-24 sm:py-32">
        <Link
          to="/"
          data-testid="impressum-back-link"
          className="inline-flex items-center gap-2 text-sm text-blau-glow hover:text-white transition-colors"
        >
          <ArrowLeft size={16} aria-hidden="true" />
          Zurück zur Startseite
        </Link>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white mt-10">
          Impressum
        </h1>

        <div className="mt-10 space-y-10 text-sm sm:text-base text-gray-400 leading-relaxed">
          <section>
            <h2 className="font-display text-xl font-bold text-white mb-3">
              Angaben gemäß § 5 DDG
            </h2>
            <p>
              Jörg Eisbach
              <br />
              BlaulichtPraxis
              <br />
              Brückenstraße 40
              <br />
              56112 Lahnstein
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-white mb-3">
              Kontakt
            </h2>
            <p>
              E-Mail:{" "}
              <a
                href="mailto:kontakt@blaulichtpraxis.de"
                data-testid="impressum-mail-link"
                className="text-blau-glow underline underline-offset-4 hover:text-white"
              >
                kontakt@blaulichtpraxis.de
              </a>
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-white mb-3">
              Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
            </h2>
            <p>
              Jörg Eisbach, Brückenstraße 40, 56112 Lahnstein
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-white mb-3">
              Streitbeilegung
            </h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="impressum-os-link"
                className="text-blau-glow underline underline-offset-4 hover:text-white"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              . Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
